/* eslint-disable react/no-unused-class-component-methods */
'use strict';

import React, { Component } from 'react'

import { HiEye, HiEyeOff } from 'react-icons/hi'

import FormElement from '@/Form/toolkit/FormElement'
import Form        from '@/Form/toolkit/Form'

import getUrlParameter from '@function/getUrlParameter'

import Loader from '@Pure/Loader'
import Link   from '@Pure/Link'

const { app, qwest } = window;

export default class LoginForm extends Component
{
	state =
	{
		status_messages: { },
		form_data: { },
		pwd_type: 'password',

		loading: getUrlParameter('token', window.location.href)
		? true
		: false,

		token: getUrlParameter('token', window.location.href)
	};

	componentDidMount ()
	{
		const component = this, props = this.props, state = this.state;

		if (state.token)
		{
			return component.loginWithToken();
		}

		const error = getUrlParameter('error', window.location.href);

		if (error === 'not_auth')
		{
			return component.setState(
			{
				info_msg: 'Votre connexion a expiré.'
			});
		}
	}

	togglePwdVisibility = () =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			pwd_type: state.pwd_type === 'password'
			? 'text'
			: 'password'
		});
	}

	loginWithToken = () =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState({ login: true });

		qwest.post('/login', { token: state.token }).then(function (xhr, response)
		{
			component.setState({ loading: false });

			component.handleValidate(response);
		})
		.catch(function (error, xhr, response)
		{
			console.error(error, xhr, response);

			component.setState({ loading: false, error: response.error });
		});
	}

	handleChange = (e, data) =>
	{
		const component = this, props = this.props, state = this.state;

		const status_messages = state.status_messages || { };
		const form_data       = state.form_data || { };

		status_messages[data.name] = status_messages[data.name] || { };

		status_messages[data.name].error   = undefined;
		status_messages[data.name].info    = undefined;
		status_messages[data.name].warning = undefined;

		Object.keys(status_messages).forEach(function (field, index)
		{
			status_messages[field].error = undefined;
		});

		form_data[data.name] = data.value;

		component.setState(
		{
			form_data: form_data,

			status_messages: status_messages,

			error: undefined,
			warning: undefined,
			info: undefined
		});
	}

	handleFailure = (response) =>
	{
		const component = this, props = this.props, state = this.state;

		const status_messages = Object.assign({ }, state.status_messages);

		Object.keys(response.fields || { }).forEach(function (field, index)
		{
			status_messages[field] = response.fields[field];
		});

		component.setState(
		{
			error: response.error,
			warning: response.warning,
			status_messages: status_messages,

			loading: false
		});
	}

	handleSubmit = () =>
	{
		const component = this, props = this.props;

		component.setState(
		{
			loading: true
		});
	}

	handleValidate = (response) =>
	{
		const component = this, props = this.props;

		app.state.session = response.session;

		app.state.cart = [];

		app.state.cart_fetched = true;

		app.state.order_process.fetched = true;

		app.emit('sessionChange', { label: 'login' });

		component.setState({ loading: false });

		if (response.pathname)
		{
			props.history.push(response.pathname);
		}
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		var form_data = component.state.form_data;
		var message, submit, loader;

		var form_status =
		[
			{ label: 'info', suffix: '--green' },
			{ label: 'warning', suffix: '--orange' },
			{ label: 'error', suffix: '--red' }
		];

		form_status.forEach(function (status, index)
		{
			if (typeof component.state[status.label] !== 'undefined')
			{
				message =
				(
					<div className={ 'c-form-message ' +
						'c-form-message' + status.suffix }>
						<div className="c-form-message__content">
							{ component.state[status.label] }
						</div>
					</div>
				);
			}
		});

		if (!message && state.info_msg)
		{
			message =
			(
				<div className={ 'c-form-message ' + 'c-form-message--orange' }>
					<div className="c-form-message__content">
						{ state.info_msg }
					</div>
				</div>
			);
		}

		if (state.loading === true)
		{
			loader =
			(
				<Loader className="c-loader" bemit={ ['white', 'bg-primary'] } />
			);
		}

		submit =
		(
			<div className="c-btn-container c-btn-container--form">
				<button type="submit" className="c-btn c-btn--primary c-btn--extra"
					onClick={ function (e) { e.target.blur(); } }>
					Se connecter
					{ loader }
				</button>
			</div>
		);

		const PwdIcon = state.pwd_type === 'password'
		? HiEye
		: HiEyeOff;

		var output =
		(
			<Form className={ props.className } action="/login"
				data={ form_data }
				onError={ component.handleFailure }
				onValidate={ component.handleValidate }
				onSubmit={ component.handleSubmit }
				history={ props.history }
				hide_button={ true }>

				<div className="home-tabs">
					<Link href="/login" className="c-tab c-tab--active">
						<div className="c-tab__label">Connexion</div>
					</Link>

					<Link href="/inscription" className="c-tab">
						<div className="c-tab__label">S'inscrire</div>
					</Link>
				</div>

				<div className="o-content form-login__content">

					<FormElement type="email" name="user[login]" label="E-mail"
						id_prefix="login-form-" data={ form_data }
						onChange={ component.handleChange }
						autoComplete="username"
					/>

					<div className="form__pwd-toggle-field">

						<FormElement type={ state.pwd_type } name="user[password]"
							label="Mot de passe" id_prefix="login-form-"
							onChange={ component.handleChange } data={ form_data }
							autoComplete="current-password"
						/>

						<button type="button" className="form__pwd-toggle-btn"
							onClick={ component.togglePwdVisibility }
							title={ state.pwd_type === 'password' ? 'Montrer le mot de passe' : 'Masquer le mot de passe' }>
							<PwdIcon className="form__pwd-toggle-icon" />
						</button>

					</div>

				</div>

				<div className="o-content">
					{ message }

					{ submit }

					<div className="form-login__forgotten-password">
						<Link href="/mot-de-passe-oublie">
							Mot de passe oublié&nbsp;?
						</Link>
					</div>
				</div>

			</Form>
		);

		return output;
	}
}